document.addEventListener("DOMContentLoaded", function () {
  // Tab switch - .bn-head
  document.querySelectorAll(".bn-head").forEach(function (el) {
    el.addEventListener("click", function () {
      var tab_id = this.getAttribute("data-id");

      document.querySelectorAll(".bn-head").forEach(e => e.classList.remove("current"));
      document.querySelectorAll(".bn-body-row-wrap").forEach(e => e.classList.remove("current"));

      this.classList.add("current");
      document.getElementById(tab_id).classList.add("current");
    });
  });

  // Read more/less toggle
  document.querySelectorAll(".rm-content-text").forEach(function (el) {
    el.addEventListener("click", function (e) {
      e.preventDefault();
      const wrapper = document.querySelector(".rm-content_wrapper");
      const textEl = this;

      wrapper.classList.toggle("active");
      textEl.textContent = textEl.textContent === "Read more" ? "Read less" : "Read more";
    });
  });

  // .mis-tab-button toggle
  document.querySelectorAll(".mis-tab-button").forEach(function (el) {
    el.addEventListener("click", function () {
      var tab_id = this.getAttribute("data-href");

      document.querySelectorAll(".mis-tab-button").forEach(e => e.classList.remove("current"));
      document.querySelectorAll(".mit-tab").forEach(e => e.classList.remove("current"));

      this.classList.add("current");
      document.getElementById(tab_id).classList.add("current");
    });
  });

  // Accordion toggle
  document.querySelectorAll(".ai-header").forEach(function (el) {
    el.addEventListener("click", function () {
      this.classList.toggle("active");
      const contentWrapper = this.nextElementSibling;
      if (contentWrapper.style.display === "none" || !contentWrapper.style.display) {
        contentWrapper.style.display = "block";
      } else {
        contentWrapper.style.display = "none";
      }
    });
  });

  // Scroll to reviews
  document.body.addEventListener("click", function (e) {
    if (e.target.closest(".loox-rating.scroll_to")) {
      const target = document.getElementById("looxReviews");
      if (target) {
        window.scrollTo({
          top: target.offsetTop - 220,
          behavior: "smooth"
        });
      }
    }
  });

  // Custom slider prev/next buttons
  document.body.addEventListener("click", function (e) {
    if (e.target.classList.contains("prev-prev-button")) {
      const gallery = e.target.closest(".gallery");
      const prevBtn = gallery.querySelector(".slick-prev");
      prevBtn?.click();

      e.target.parentElement.querySelectorAll(".prev-prev-button, .prev-next-button")
        .forEach(btn => btn.classList.remove("disabled"));

      if (prevBtn?.classList.contains("slick-disabled")) {
        e.target.classList.add("disabled");
      }
    }

    if (e.target.classList.contains("prev-next-button")) {
      const gallery = e.target.closest(".gallery");
      const nextBtn = gallery.querySelector(".slick-next");
      nextBtn?.click();

      e.target.parentElement.querySelectorAll(".prev-prev-button, .prev-next-button")
        .forEach(btn => btn.classList.remove("disabled"));

      if (nextBtn?.classList.contains("slick-disabled")) {
        e.target.classList.add("disabled");
      }
    }
  });

  // Cookie helpers
  function getCookie(name) {
    const v = document.cookie.match("(^|;) ?"+name+"=([^;]*)(;|$)");
    return v ? v[2] : null;
  }

  function setCookie(name, value, days) {
    const d = new Date();
    d.setTime(d.getTime() + (24 * 60 * 60 * 1000 * days));
    document.cookie = name + "=" + value + ";path=/;expires=" + d.toGMTString();
  }

  // Category selection
  document.querySelectorAll(".category_selection .page_link").forEach(function (el) {
    el.addEventListener("click", function () {
      const gender = this.getAttribute("data-gender");
      if (gender === "cats") {
        setCookie("animaltype", "cats", 1);
      } else {
        setCookie("animaltype", "dogs", 1);
      }
    });
  });

  // Template search page logic
  if (document.body.classList.contains("template--search")) {
    const animalType = getCookie("animaltype");

    document.querySelectorAll(".category_selection .page_link").forEach(el => el.classList.remove("active"));
    document.querySelectorAll('[class^="animaltype_"]').forEach(el => el.setAttribute("hidden", true));

    if (animalType === "cats") {
      document.querySelector('.category_selection .page_link[data-animaltype="cats"]')?.classList.add("active");
      document.querySelector(".animaltype_cats")?.removeAttribute("hidden");

      document.querySelectorAll('a[href^="/"]').forEach(link => {
        link.setAttribute("href", "/pages/cats");
      });
    } else {
      document.querySelector('.category_selection .page_link[data-animaltype="dogs"]')?.classList.add("active");
      document.querySelector(".animaltype_dogs")?.removeAttribute("hidden");
    }
  }

  // Toggle product offer header
  document.querySelectorAll(".product-offer-header").forEach(function (el) {
    el.addEventListener("click", function () {
      this.classList.toggle("active");
      const nextEl = this.nextElementSibling;
      nextEl.style.display = nextEl.style.display === "block" ? "none" : "block";
    });
  });

  // Copy offer code
  document.body.addEventListener("click", function (e) {
    const block = e.target.closest(".product-offer-code-block");
    if (block) {
      const code = block.querySelector(".product-offer-code").textContent;
      const copyText = block.querySelector(".product-offer-copy-code");

      const temp = document.createElement("input");
      document.body.appendChild(temp);
      temp.value = code;
      temp.select();
      document.execCommand("copy");
      document.body.removeChild(temp);

      copyText.textContent = "Copied";
      setTimeout(() => {
        copyText.textContent = "Copy";
      }, 1000);
    }
  });
});
